import App from './App';
import './style.css';
export default function IntegratedInterviewApp() { return <div className="agent-shell-interview"><App /></div>; }
